import {
  RESET_CAPTCHA_REGISTRATION,
  SET_BUSINESS_INFORMATION,
} from './constants';

export function setBusinessInfo(businessInfo) {
  return { type: SET_BUSINESS_INFORMATION, payload: { businessInfo } };
}

export function resetCaptcha(params) {
  return {
    type: RESET_CAPTCHA_REGISTRATION,
    payload: { resetCaptcha: params },
  };
}
